"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var DashboardRemove = /** @class */ (function () {
    function DashboardRemove() {
        this.active = false;
    }
    DashboardRemove.prototype.init = function (opts) {
        this.dashboardList = opts.dashboardList;
        this.dashboard = opts.dashboard;
        this.active = true;
    };
    DashboardRemove.prototype._close = function () {
        //this.dashboardList = undefined;
        //this.dashboard = undefined;
        this.active = false;
    };
    DashboardRemove.prototype.save = function () {
        if (this.dashboard) {
            this.dashboardList.remove(this.dashboard);
        }
        else {
            this.dashboardList.clear();
        }
        this._close();
    };
    DashboardRemove.prototype.cancel = function () {
        this._close();
    };
    __decorate([
        mobx_1.observable
    ], DashboardRemove.prototype, "active", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardRemove.prototype, "dashboardList", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardRemove.prototype, "dashboard", void 0);
    __decorate([
        mobx_1.action
    ], DashboardRemove.prototype, "init", null);
    __decorate([
        mobx_1.action
    ], DashboardRemove.prototype, "_close", null);
    __decorate([
        mobx_1.action
    ], DashboardRemove.prototype, "save", null);
    __decorate([
        mobx_1.action
    ], DashboardRemove.prototype, "cancel", null);
    return DashboardRemove;
}());
exports.DashboardRemove = DashboardRemove;
